import {ORGANIZATIONAL_NETWORKING} from '../activity-type/activity-type.const';
import {MEETINGS} from '../activity-type/activity-type.data';
import {CONFLICT_RESOLUTION} from '../activity-type/conflict-resolutions/conflict-resolution.consts';
import {ORGANIZATIONAL_DEVELOPMENT} from '../activity-type/organizational-development/organizational-development.const';
import {ORGANIZATIONAL_EVENTS} from '../activity-type/organizational-events/organizational-events.const';
import {OUTREACH} from '../activity-type/outreach/outreach.const';
import {TRAINING} from '../activity-type/training/training.const';

export const STEP_STATUS_PENDING_ID = '65f062bc2d71dfb4e1880122';
export const STEP_STATUS_PENDING_LABEL = 'Pending';

export const STEP_STATUS_CAMPLETED_ID = '65f062bc2d71dfb4e1880123';
export const STEP_STATUS_CAMPLETED_LABLE = 'Completed';

export const STEP_STATUS_CANCELED_ID = '65f062bc2d71dfb4e1880124';

export const STEP_GENERAL_ID = '65f062bc2d71dfb4e1880129';
export const STEP_MEDIATION_ID = '65f062bc2d71dfb4e1880130';
export const STEP_CONCILIATION_ID = '65f062bc2d71dfb4e1880131';
export const STEP_FACILITATION_ID = '65f062bc2d71dfb4e1880132';
export const STEP_CONFLICT_COACHING_ID = '65f062bc2d71dfb4e1880133';
export const STEP_RESTORATIVE_PRACTICES_ID = '65f062bc2d71dfb4e1880134';
export const STEP_DELIBERATIVE_DIALOGUE_ID = '65f062bc2d71dfb4e1880135';
export const STEP_FOLLOW_UP_ID = '65f062bc2d71dfb4e1880136';
export const STEP_TRAINING_ID = '65f062bc2d71dfb4e1880137';
export const STEP_MENTORING_ID = '65f062bc2d71dfb4e1880138';
export const STEP_OUTREACH_ID = '65f062bc2d71dfb4e1880139';
export const STEP_CONTENT_CREATION_ID = '65f062bc2d71dfb4e188013a';
export const STEP_MEETING_ID = '65f062bc2d71dfb4e188013b';
export const STEP_RESEARCH_ID = '65f062bc2d71dfb4e188013c';

export const STEP_INTAKE_ID = '65f062bc2d71dfb4e188014c';
export const STEP_INTAKE_LABEL = 'Intake';

export const STEP_INTAKE = {_id: STEP_INTAKE_ID, label: STEP_INTAKE_LABEL};

const CR = CONFLICT_RESOLUTION._id;
const TR = TRAINING._id;
const OR = OUTREACH._id;
const OE = ORGANIZATIONAL_EVENTS._id;
const ON = ORGANIZATIONAL_NETWORKING._id;
const OD = ORGANIZATIONAL_DEVELOPMENT._id;
const ME = MEETINGS._id;

export const STEPS = [
    {
        _id: STEP_GENERAL_ID,
        label: 'General',
        activityTypes: [CR, TR, OR, OE, ON, OD, ME],
    },
    {
        _id: STEP_MEDIATION_ID,
        label: 'Mediation',
        activityTypes: [CR],
    },
    {
        _id: STEP_CONCILIATION_ID,
        label: 'Conciliation',
        activityTypes: [CR],
    },
    {
        _id: STEP_FACILITATION_ID,
        label: 'Facilitation',
        activityTypes: [CR],
    },
    {
        _id: STEP_CONFLICT_COACHING_ID,
        label: 'Conflict Coaching',
        activityTypes: [CR],
    },
    {
        _id: STEP_RESTORATIVE_PRACTICES_ID,
        label: 'Restorative Practices',
        activityTypes: [CR],
    },
    {
        _id: STEP_DELIBERATIVE_DIALOGUE_ID,
        label: 'Deliberative Dialogue',
        activityTypes: [CR],
    },
    {
        _id: STEP_FOLLOW_UP_ID,
        label: 'Follow Up',
        activityTypes: [CR, TR, OR, OE, ON, OD, ME],
    },
    {
        _id: STEP_TRAINING_ID,
        label: 'Training',
        activityTypes: [TR],
    },
    // {
    //     _id: STEP_MENTORING_ID,
    //     label: 'Mentoring',
    //     activityTypes: [],
    // },
    {
        _id: STEP_OUTREACH_ID,
        label: 'Outreach',
        activityTypes: [TR, OR, OE, OD],
    },
    {
        _id: STEP_CONTENT_CREATION_ID,
        label: 'Content Creation',
        activityTypes: [TR, OR, OE, ON, OD],
    },
    {
        _id: STEP_MEETING_ID,
        label: 'Meeting',
        activityTypes: [TR, OR, OE, ON, OD, ME],
    },
    {
        _id: STEP_RESEARCH_ID,
        label: 'Research',
        activityTypes: [TR, OR, OE, ON, OD],
    },
].map(d => ({...d, active: true}));

export const STEP_INTERPRETER_TYPE = [
    {
        label: 'Formal',
        _id: '507f191e810c19729de86101',
        description: 'Interpretation provided by qualified interpreter',
    },
    {
        label: 'Informal',
        _id: '507f191e810c19729de86102',
        description: 'Interpretation provided by family member, friend, or other individual',
    },
].map(d => ({...d, active: true, editable: false}));

export const STEP_STATUS_PENDING = {_id: STEP_STATUS_PENDING_ID, label: STEP_STATUS_PENDING_LABEL};
export const STEP_STATUS_COMPLETED = {_id: STEP_STATUS_CAMPLETED_ID, label: STEP_STATUS_CAMPLETED_LABLE};
export const STEP_STATUS_CANCELED = {_id: STEP_STATUS_CANCELED_ID, label: 'Canceled'};

export const STEP_STATUS = [STEP_STATUS_PENDING, STEP_STATUS_COMPLETED, STEP_STATUS_CANCELED].map(d => ({
    ...d,
    active: true,
}));
